// @flow
// Libs
import React from 'react'

// Components
import SelectWithRange from './SelectWithRange'

// Constants
import { ROTATE_TOOL_CONFIG } from '../../constants'

// Types
type Props = {
  operation: Object,
  selectedFeatureIndices: Array<number>,
  onChange: Function,
}

export default function RotateGrid (props: Props): React.Element<any> {
  return <SelectWithRange {...props} config={ROTATE_TOOL_CONFIG} stylingClasses='select-map-grid-tool' />
}
